import { render, staticRenderFns } from "./stockInquiry.vue?vue&type=template&id=b3be0a24&scoped=true"
import script from "./stockInquiry.vue?vue&type=script&lang=js"
export * from "./stockInquiry.vue?vue&type=script&lang=js"
import style0 from "./stockInquiry.vue?vue&type=style&index=0&id=b3be0a24&prod&scoped=true&lang=css"
import style1 from "./stockInquiry.vue?vue&type=style&index=1&id=b3be0a24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3be0a24",
  null
  
)

export default component.exports